import { X } from "lucide-react";

type AnnouncementBarProps = {
  onDismiss: () => void;
};

const AnnouncementBar = ({ onDismiss }: AnnouncementBarProps) => (
  <div
    role="region"
    aria-label="Announcement"
    className="relative flex h-9 items-center justify-center border-b border-primary/10 bg-primary/[0.06] px-4 md:px-8"
  >
    <p className="truncate pr-8 text-xs font-heading font-semibold text-foreground md:text-[13px]">
      <span className="text-primary">Live</span>
      <span className="mx-1.5 text-muted-foreground" aria-hidden>
        ·
      </span>
      Dibs for Youth is featured at Impact, IRL on 31 Dec 2026
    </p>
    <button
      type="button"
      onClick={onDismiss}
      aria-label="Dismiss announcement"
      className="absolute right-1.5 top-1/2 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground md:right-[22px]"
    >
      <X className="h-4 w-4" />
    </button>
  </div>
);

export default AnnouncementBar;
